document.addEventListener( 'DOMContentLoaded', () => {

	// ── Accordion ──────────────────────────────────────────────
	document.querySelectorAll( '.faq-block' ).forEach( ( block ) => {
		block.querySelectorAll( '.faq-trigger' ).forEach( ( trigger ) => {
			trigger.addEventListener( 'click', () => {
				const expanded  = trigger.getAttribute( 'aria-expanded' ) === 'true';
				const answerId  = trigger.getAttribute( 'aria-controls' );
				const answer    = document.getElementById( answerId );
				const icon      = trigger.querySelector( '.faq-icon' );
				const iconVLine = trigger.querySelector( '.faq-icon-v' );

				if ( expanded ) {
					trigger.setAttribute( 'aria-expanded', 'false' );
					answer.style.maxHeight = '0';
					if ( icon ) icon.style.transform = 'rotate(0deg)';
					if ( iconVLine ) iconVLine.style.opacity = '1';
				} else {
					// Close any other open item in the same block
					block.querySelectorAll( '.faq-trigger[aria-expanded="true"]' ).forEach( ( openTrigger ) => {
						const openAnswerId = openTrigger.getAttribute( 'aria-controls' );
						const openAnswer   = document.getElementById( openAnswerId );
						openTrigger.setAttribute( 'aria-expanded', 'false' );
						if ( openAnswer ) openAnswer.style.maxHeight = '0';
						const openIcon  = openTrigger.querySelector( '.faq-icon' );
						const openVLine = openTrigger.querySelector( '.faq-icon-v' );
						if ( openIcon ) openIcon.style.transform = 'rotate(0deg)';
						if ( openVLine ) openVLine.style.opacity = '1';
					} );

					trigger.setAttribute( 'aria-expanded', 'true' );
					// Measure inner content height
					const inner = answer.firstElementChild;
					answer.style.maxHeight = ( inner ? inner.offsetHeight + 32 : 200 ) + 'px';
					if ( icon ) icon.style.transform = 'rotate(45deg)';
					if ( iconVLine ) iconVLine.style.opacity = '0';
				}
			} );
		} );
	} );

	// ── Scroll-in animation ────────────────────────────────────
	const EASING   = 'cubic-bezier(0.22, 1, 0.36, 1)';
	const DURATION = 0.5;
	const STAGGER  = 0.07;

	document.querySelectorAll( '.faq-block .faq-header' ).forEach( ( header ) => {
		header.style.opacity    = '0';
		header.style.transform  = 'translateY(24px)';
		header.style.transition = `opacity ${ DURATION }s ${ EASING }, transform ${ DURATION }s ${ EASING }`;

		const obs = new IntersectionObserver( ( entries, o ) => {
			entries.forEach( ( entry ) => {
				if ( entry.isIntersecting ) {
					header.style.opacity   = '1';
					header.style.transform = 'translateY(0)';
					o.unobserve( entry.target );
				}
			} );
		}, { threshold: 0.3 } );
		obs.observe( header );
	} );

	document.querySelectorAll( '.faq-block .faq-item' ).forEach( ( item, i ) => {
		item.style.opacity    = '0';
		item.style.transform  = 'translateY(16px)';
		item.style.transition = `opacity ${ DURATION }s ${ EASING } ${ i * STAGGER + 0.15 }s, transform ${ DURATION }s ${ EASING } ${ i * STAGGER + 0.15 }s`;

		const obs = new IntersectionObserver( ( entries, o ) => {
			entries.forEach( ( entry ) => {
				if ( entry.isIntersecting ) {
					item.style.opacity   = '1';
					item.style.transform = 'translateY(0)';
					o.unobserve( entry.target );
				}
			} );
		}, { threshold: 0.1 } );
		obs.observe( item );
	} );

} );
